import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { BrowserRouter as Router, Switch } from 'react-router-dom'
import {auth} from '../firebase/firebase'
import { authLoaded, authLoading, authLogin } from '../reducer/AuthReducer'
import { startLoadingPerfil } from '../reducer/PerfilReducer'
import RoutersPrivate from './RoutersPrivate'
import RoutersPublic from './RoutersPublic'
import PrivateRouter from './PrivateRouter'
import PublicRouter from './PublicRouter'
import { startLoadingFrase } from '../reducer/FraseDelDiaReducer'
import { startLoadingAsignatura } from '../reducer/AsignaturasReducer'
import LoadingApp from '../components/tools/LoadingApp'
import { startLoadingdocentes } from '../reducer/DocentesReducer'
const AppRouter = () => {
    const dispatch = useDispatch();
    const { rol } = useSelector(state => state.perfil)
    const { loading, isAuthenticate } = useSelector(state => state.auth)
    useEffect(() => {
        dispatch(authLoading())
        auth.onAuthStateChanged(async user => {
            if (user?.uid) {
                dispatch(authLogin())
                dispatch(startLoadingPerfil(user.email))
                if (rol === 'admin') {
                    dispatch(startLoadingdocentes())
                }
                if (rol === 'docente') {
                    dispatch(startLoadingFrase(user.email))
                    dispatch(startLoadingAsignatura(user.email))
                }
            }else {
                dispatch(authLoaded())
            }
        })
    }, [rol, dispatch])

    if (loading) {
        return <LoadingApp />
    }
    
    return (
        <Router>
            <Switch>
                {
                    isAuthenticate
                    ?   <PrivateRouter
                            path='/'
                            component={RoutersPrivate}
                            isAuthenticate={isAuthenticate}
                        />
                    :   <PublicRouter
                            path='/'
                            component={RoutersPublic}
                            isAuthenticate={isAuthenticate}
                        />
                }
            </Switch>
        </Router>
    )
}

export default AppRouter
